export type NotificationKind = 'message' | 'worksheet' | 'appointment';

export enum NotificationTypeEnum {
  CreateMessage = 1,
  UpdateMessage = 2,
  CompletedWorksheet = 3,
  CreateWorksheet = 4,
  UpdateWorksheet = 5,
  DeleteWorksheet = 6,
  CreateCalendarEvent = 7,
  UpdateCalendarEvent = 8,
  DeleteCalendarEvent = 9
}

export const kindByType: Record<NotificationTypeEnum, NotificationKind> = {
  [NotificationTypeEnum.CreateMessage]: 'message',
  [NotificationTypeEnum.UpdateMessage]: 'message',
  [NotificationTypeEnum.CompletedWorksheet]: 'worksheet',
  [NotificationTypeEnum.CreateWorksheet]: 'worksheet',
  [NotificationTypeEnum.UpdateWorksheet]: 'worksheet',
  [NotificationTypeEnum.DeleteWorksheet]: 'worksheet',
  [NotificationTypeEnum.CreateCalendarEvent]: 'appointment',
  [NotificationTypeEnum.UpdateCalendarEvent]: 'appointment',
  [NotificationTypeEnum.DeleteCalendarEvent]: 'appointment'
};

export enum NotificationPlatform {
  FcmV1 = 1,
  Apns
}